import * as React from 'react';

import * as style from '../../style.css';

export interface IHeaderRowProps {
  floating?: boolean;
  headers: React.ReactNode[];
  rowRef?: React.Ref<HTMLDivElement>;
}

export const HeaderRow = ({ floating = false, headers, rowRef }: IHeaderRowProps) => {
  return (
    <div
      ref={rowRef}
      className={floating ? style['row-floating'] : style['row']}
      data-floating-header={floating ? 'true' : undefined}
      role="row"
    >
      {headers.map((header, columnIndex) => (
        <div className={style['header-cell']} key={columnIndex} role="columnheader">
          {header}
        </div>
      ))}
    </div>
  );
};
